import type * as React from 'react';
import { cn } from '@/shared/lib/cn';

/**
 * Placeholder block while content loads. Hidden from assistive technology: put
 * `aria-busy` and a status label on the region that is loading.
 */
function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      aria-hidden="true"
      className={cn('rounded-sm bg-secondary motion-safe:animate-pulse', className)}
      {...props}
    />
  );
}

export { Skeleton };
